// extracted by mini-css-extract-plugin
export default {"loadingBody":"loading-page_loadingBody__LoVTz","animateText":"loading-page_animateText__LAAf6","typing":"loading-page_typing__GLDtm","text":"loading-page_text__vm1uB"};